// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610070735/js/" + chunkId + "." + {"44":"87c1d144","225":"4120e25e","481":"557a7263","486":"a2754406","770":"e90ee45a"}[chunkId] + ".0.5794872567767817.chunk.js";
};